export type ClientConfig = {
    authority: string;
    clientId: string;
    environment: string;
};

export async function loadClientConfig(fetchConfig: typeof fetch = fetch): Promise<ClientConfig> {
    const response = await fetchConfig('/api/config');
    if (!response.ok) {
        throw new Error(`GET /api/config returned ${response.status}`);
    }
    return response.json();
}
